import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { addPersonalitySlug } from './languageSlice/LanguageSlice';
import type { RootState } from '../index';

export const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  matcher: isAnyOf(addPersonalitySlug),
  effect: (action, listenerApi) =>
    localStorage.setItem(
      'preferred_language',
      JSON.stringify((listenerApi.getState() as RootState).language)
    )
});
